import { put, call, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import { sagaActions } from '../sagas'
import { mapActivityData } from 'utils/activities'
import moment from 'moment'
import notificationSound from 'sounds/notification.mp3'
import {
  add as addHeartbeat,
} from 'store/redux/heartbeats'
import {
  add as addNotification,
  remove as removeNotification,
  setArray as setNotificationsArray,
  setWasRead as setNotificationWasRead,
  setArray as setNotificationArray,
  setUnreadCount as setUnreadNotificationCount
} from 'store/redux/notifications'
import {
  addUser as addUserToGroup,
  removeUser as removeUserFromGroup,
  addUserOwner as addUserOwnerToGroup,
  removeUserOwner as removeUserOwnerFromGroup,
  addGroupOwner as addGroupOwnerToGroup,
  removeGroupOwner as removeGroupOwnerFromGroup,
  setName as setUserGroupName,
  setDescription as setUserGroupDescription
} from 'store/redux/userGroups'
import {
  setSettings as setCurrentUserSettings
} from 'store/redux/currentUser'
import {
  add as addUser,
  setUser
} from 'store/redux/users'
import {
  add as addUserRole,
  remove as removeUserRole
} from '../redux/userRoles'
import {
  add as addUserAvatar
} from '../redux/userAvatars'
import {
  set as setLicense
} from 'store/redux/license'
import {
  add as addDocumentSource,
  remove as removeDocumentSource,
  setDocumentSource
} from 'store/redux/documentSources'
import {
  add as addDocumentTemplateSource,
  remove as removeDocumentTemplateSource,
} from 'store/redux/documentTemplateSources'
import {
  add as addPersonalDate,
  remove as removePersonalDate,
  setName as setPersonalDateName,
  setTimestamp as setPersonalDateTimestamp
} from 'store/redux/personalDates'
import {
  set as setSettings
} from 'routes/Home/redux/settings'
import {
  add as addBookmark,
  remove as removeBookmark
} from '../redux/bookmarks'
import {
  add as addBoard,
  setIsLocked as setBoardIsLocked,
} from '../redux/boards'
import {
  add as addBlocker,
  set as setBlocker,
  remove as removeBlocker,
  setPosition as setBlockerPosition,
} from '../redux/blockers'
import {
  add as addCardBlocker,
  set as setCardBlocker,
  remove as removeCardBlocker,
} from 'store/redux/cardBlockers'
import {
  add as addDescendantBlockedCard,
  remove as removeDescendantBlockedCard,
} from 'store/redux/descendantBlockedCards'
import {
  add as addPreviousBlockedCard,
  remove as removePreviousBlockedCard,
} from 'store/redux/previousBlockedCards'
import {
  add as addObservedTag,
  remove as removeObservedTag,
} from 'store/redux/observedTags'
import * as CalendarItemTypes from 'const/CalendarItemTypes'
import fetchUserBlockerCount from '../sagas/fetchUserBlockerCount'

const getUserByProfileKey = (state, profileKey) => {
  let user = null

  const userKeys = Object.keys(state.kanbo.users)
  const length = userKeys.length

  if (length) {
    for (let i = 0; i < length; i++) {
      const _user = state.kanbo.users[userKeys[i]]
      if (_user.profileKey === profileKey) {
        user = _user
        break
      }
    }
  }

  return user
}

let notificationAudio = null
try {
  notificationAudio = new Audio(notificationSound)
} catch (error) { } // eslint-disable-line no-empty
let lastNotifyMoment = null

export default function * channelData (action) {
  const { channel, actionName, elementName, data } = action.payload

  const state = yield select()

  const currentUserId = state.kanbo.currentUser.id
  const currentUserSettings = state.kanbo.currentUser.settings

  if (actionName + elementName === 'Heartbeat/Data/Heartbeats') {
    const { UserId, Timestamp, Heartbeats } = data

    yield put(Heartbeats.map(Heartbeat => addHeartbeat({
      userId: UserId,
      timestamp: Timestamp,
      location: Heartbeat.Location,
      action: Heartbeat.Action
    })))
  } else if (actionName + elementName === 'AddBlocker/Data/Blocker') {
    const Blocker = data

    yield put(addBlocker({
      id: Blocker.Id,
      type: Blocker.Type,
      name: Blocker.Name,
      description: Blocker.Description && JSON.parse(Blocker.Description),
      position: Blocker.Position,
    }))
  } else if (actionName + elementName === 'RenameBlocker/Data/BlockerName') {
    const { Id, Name } = data

    yield put(setBlocker({
      id: Id,
      name: Name,
    }))
  } else if (actionName + elementName === 'ChangeBlockerDescription/Data/BlockerDescription') {
    const { Id, Description } = data

    yield put(setBlocker({
      id: Id,
      description: Description && JSON.parse(Description),
    }))
  } else if (actionName + elementName === 'RemoveBlocker/Primitive/Int32') {
    const { Value } = data

    yield put(removeBlocker({
      id: Value,
    }))
  } else if (elementName === '/Positions/Blockers') {
    const { Positions } = data

    if (Positions.length) {
      yield put(Positions.map(({ Id, Position }) => setBlockerPosition({
        blockerId: Id,
        position: Position
      })))
    }
  } else if (actionName + elementName === 'AddBlockerToCard/Data/CardBlocker') {
    const CardBlocker = data

    yield put([
      addBlocker({
        id: CardBlocker.BlockerId,
        type: CardBlocker.BlockerType,
        name: CardBlocker.Name,
        description: CardBlocker.Description && JSON.parse(CardBlocker.Description),
      }),
      addCardBlocker({
        cardBlocker: {
          id: CardBlocker.Id,
          blockerId: CardBlocker.BlockerId,
          cardId: CardBlocker.CardId,
          reason: CardBlocker.Reason,
          userId: CardBlocker.UserId,
          creationDate: CardBlocker.CreationDate,
          createdBy: CardBlocker.CreatedBy,
        },
      }),
    ])
  } else if (actionName + elementName === 'ChangeCardBlockerReason/Data/CardBlockerReason') {
    const { Id, Reason } = data

    yield put(setCardBlocker({
      id: Id,
      reason: Reason,
    }))
  } else if (actionName + elementName === 'ChangeCardBlockerUser/Data/CardBlockerResponsibleUser') {
    const { Id, UserId } = data

    yield put(setCardBlocker({
      id: Id,
      userId: UserId,
    }))
  } else if (actionName + elementName === 'RemoveBlockerFromCard/Primitive/Int32') {
    const { Value } = data

    yield put(removeCardBlocker({
      cardBlockerId: Value,
    }))
  } else if (actionName + elementName === 'AddDescendantBlockedCard/Data/DescendantBlockedCardData') {
    const { CardId, DescendantCardId } = data

    yield put(addDescendantBlockedCard({
      cardId: CardId,
      descendantCardId: DescendantCardId,
    }))
  } else if (actionName + elementName === 'RemoveDescendantBlockedCard/Data/DescendantBlockedCardData') {
    const { CardId, DescendantCardId } = data

    yield put(removeDescendantBlockedCard({
      cardId: CardId,
      descendantCardId: DescendantCardId,
    }))
  } else if (actionName + elementName === 'AddPreviousBlockedCard/Data/PreviousBlockedCardData') {
    const { CardId, PreviousCardId } = data

    yield put(addPreviousBlockedCard({
      cardId: CardId,
      previousCardId: PreviousCardId,
    }))
  } else if (actionName + elementName === 'RemovePreviousBlockedCard/Data/PreviousBlockedCardData') {
    const { CardId, PreviousCardId } = data

    yield put(removePreviousBlockedCard({
      cardId: CardId,
      previousCardId: PreviousCardId,
    }))
  }

  if (channel === 'documents-sources') { // Document soruces channel
    if (actionName + elementName === 'AddDocumentsSource/Data/DocumentsSource') {
      const DocumentSource = data
      yield put(addDocumentSource({
        id: DocumentSource.Id,
        name: DocumentSource.Name,
        url: DocumentSource.Url
      }))
    } else if (actionName + elementName === 'RemoveDocumentsSource/Data/DocumentsSource') {
      const DocumentSource = data
      yield put(removeDocumentSource({
        id: DocumentSource.Id
      }))
    } else if (actionName + elementName === 'RenameDocumentsSource/Data/DocumentsSourceName') {
      const DocumentSource = data
      yield put(setDocumentSource({
        id: DocumentSource.Id,
        name: DocumentSource.Name
      }))
    }
  } else if (channel === 'document-template-sources') {
    if (actionName + elementName === 'AddDocumentTemplateSource/Data/AddDocumentTemplateSource') {
      const DocumentSource = data
      yield put(addDocumentTemplateSource({
        id: DocumentSource.Id,
        name: DocumentSource.Name,
        url: DocumentSource.Url
      }))
    } else if (actionName + elementName === 'RemoveDocumentTemplateSource/Data/RemoveDocumentTemplateSource') {
      yield put(removeDocumentTemplateSource({
        id: data.Id
      }))
    }
  } else if (channel === 'boardCollectionSettings') { // Board collection settings channel
    if (actionName + elementName === 'ChangeBoardsCollectionSettings/Data/Settings') {
      const { Settings } = data
      yield put(setSettings({
        allowRemoveBoard: Settings.AllowRemoveBoard,
        lang: Settings.Lang,
        officeAppLauncher: Settings.OfficeAppLauncher,
        siteType: Settings.SiteType,
        boardTemplateId: Settings.BoardTemplateId,
      }))
    }
  } else if (channel === 'users') { // Users channel
    if (actionName + elementName === 'AddUser/Data/User') {
      const User = data

      yield put(addUser({
        id: User.Id,
        name: User.Name,
        email: User.Email,
        profileKey: User.ProfileKey,
        licenseType: User.LicenseType,
        isActive: User.Active,
        isLoaded: true,
        isLoading: false
      }))
    }
  } else if (channel === 'userRoles') { // User roles channel
    if (actionName + elementName === 'AddUserRole/Data/UserRole') {
      const { UserId, Name } = data

      yield put(addUserRole({
        userId: UserId,
        role: Name,
      }))
    } else if (actionName + elementName === 'RemoveUserRole/Data/UserRole') {
      const { UserId, Name } = data

      yield put(removeUserRole({
        userId: UserId,
        role: Name,
      }))
    }
  } else if (channel === 'profiles') { // Profile channel
    if (actionName + elementName === 'ActivateProfile/Primitive/String') {
      const { Value } = data
      const user = getUserByProfileKey(state, Value)
      if (user) {
        yield put(setUser({
          id: user.id,
          isActive: true
        }))
      }
      yield put(setLicense({
        writersCurrent: state.kanbo.license.writersCurrent + 1
      }))
    } else if (actionName + elementName === 'DeactivateProfile/Primitive/String') {
      const { Value } = data
      const user = getUserByProfileKey(state, Value)
      if (user) {
        yield put(setUser({
          id: user.id,
          isActive: false
        }))
      }
      yield put(setLicense({
        writersCurrent: state.kanbo.license.writersCurrent - 1
      }))
    } else if (actionName + elementName === 'SetMyAvatar/Primitive/String') {
      const { Value } = data

      yield put(addUserAvatar({
        profileKey: Value,
        data: {
          avatarTimestamp: Date.now()
        }
      }))
    }
  } else if (channel.indexOf('security-group-') === 0) { // Security group channels
    const userGroupId = +channel.split('security-group-')[1]

    if (actionName + elementName === 'AddUserToGroup/Data/User') {
      const { Id } = data
      yield put(addUserToGroup({
        id: userGroupId,
        userId: Id
      }))
    } else if (actionName + elementName === 'RemoveUserFromGroup/Data/User') {
      const { Id } = data
      yield put(removeUserFromGroup({
        id: userGroupId,
        userId: Id
      }))
    } else if (actionName + elementName === 'AddUserOwningGroup/Data/UserOwningGroup') {
      const { GroupId, OwningUserId } = data
      yield put(addUserOwnerToGroup({
        id: GroupId,
        userId: OwningUserId
      }))
    } else if (actionName + elementName === 'RemoveUserOwningGroup/Data/UserOwningGroup') {
      const { GroupId, OwningUserId } = data
      yield put(removeUserOwnerFromGroup({
        id: GroupId,
        userId: OwningUserId
      }))
    } else if (actionName + elementName === 'AddGroupOwningGroup/Data/GroupOwningGroup') {
      const { GroupId, OwningGroupId } = data
      yield put(addGroupOwnerToGroup({
        id: GroupId,
        groupId: OwningGroupId
      }))
    } else if (actionName + elementName === 'RemoveGroupOwningGroup/Data/GroupOwningGroup') {
      const { GroupId, OwningGroupId } = data
      yield put(removeGroupOwnerFromGroup({
        id: GroupId,
        groupId: OwningGroupId
      }))
    } else if (actionName + elementName === 'RenameGroup/Data/Group') {
      const { Id, Name } = data
      yield put(setUserGroupName({
        id: Id,
        name: Name,
      }))
    } else if (actionName + elementName === 'SetGroupDescription/Data/Group') {
      const { Id, Description } = data
      yield put(setUserGroupDescription({
        id: Id,
        description: Description,
      }))
    }
  } else if (channel === '@' + currentUserId) {
    if (actionName + elementName === 'AddBoard/Data/Board') {
      const { Id, Name, Background, IsClosed, IsTemplate, IsPublic, IsLocked } = data

      yield put(addBoard({
        id: Id,
        name: Name,
        background: Background,
        hasAccess: true,
        isClosed: IsClosed,
        isTemplate: IsTemplate,
        isPublic: IsPublic,
        isLocked: IsLocked,
      }))
    } else if (actionName + elementName === 'UnlockBoard/Primitive/Int32') {
      const { Value } = data

      yield put(setBoardIsLocked({
        id: Value,
        isLocked: false,
      }))
    } else if (actionName + elementName === 'AddObservedTag/Data/Tag') {
      const { Id, Type, Name } = data

      yield put(addObservedTag({
        tag: {
          Id,
          Type,
          Name,
        },
      }))
    } else if (actionName + elementName === 'RemoveObservedTag/Data/Tag') {
      const { Name } = data

      yield put(removeObservedTag({
        tagName: Name,
      }))
    } else if (actionName + elementName === 'BoardsPermissionChange/Data/Array<Int32>') {
      const boardIds = data

      for (let i = 0, length = boardIds.length; i < length; i++) {
        const id = boardIds[i]

        try {
          const Board = yield call(apiGetData, 'BoardTile', {
            id
          })

          yield put(addBoard({
            id: Board.Id,
            name: Board.Name,
            background: Board.Background,
            isObserved: Board.IsObserved,
            hasAccess: true,
            isClosed: Board.IsClosed,
            isTemplate: Board.IsTemplate,
            isPublic: Board.IsPublic,
            isLocked: Board.IsLocked,
            permissionLevel: Board.PermissionLevel,
          }))
        } catch (error) {
          if (error.code === 601) {
            yield put(addBoard({
              id,
              name: '',
              background: null,
              isObserved: false,
              hasAccess: false,
              isClosed: false,
              isTemplate: false,
              isPublic: false,
              permissionLevel: 0
            }))
          }
        }
      }
    } else if (actionName === 'MarkAllNotificationsAsRead') {
      const array = []

      state.kanbo.notifications.notifications.forEach(id => {
        const wasRead = state.kanbo.notifications.notificationsById[id].wasRead
        if (!wasRead) {
          array.push({ id, wasRead: true })
        }
      })

      yield put(setNotificationArray(array))
      yield put(setUnreadNotificationCount({
        unreadCount: 0
      }))

      yield put(sagaActions.fetchUnreadNotificationsCount())
    } else if (actionName + elementName === 'MarkNotificationAsRead/Primitive/Int32') {
      const { Value } = data

      yield put(setNotificationWasRead({
        id: Value,
        wasRead: true
      }))

      yield put(sagaActions.fetchUnreadNotificationsCount())
    } else if (actionName + elementName === 'MarkNotificationAsUnread/Data/Notification') {
      const notification = mapActivityData(data)

      yield put(addNotification({
        ...notification,
        wasRead: false
      }))

      yield put(sagaActions.fetchUnreadNotificationsCount())
    } else if (actionName + elementName === 'MarkTaggedNotificationsAsRead/Data/NotificationsIDs') {
      const { IDs } = data

      const array = []

      IDs.forEach(id => {
        if (state.kanbo.notifications.notificationsById[id]) {
          array.push({
            id,
            wasRead: true
          })
        }
      })

      yield put(setNotificationsArray(array))

      yield put(sagaActions.fetchUnreadNotificationsCount())
    } else if (actionName + elementName === 'AddNotification/Data/Notification') {
      if (currentUserSettings.notificationSound) {
        const nowMoment = moment()
        if (notificationAudio &&
            (!lastNotifyMoment ||
            nowMoment.diff(lastNotifyMoment, 'seconds') > 30)) {
          notificationAudio.play()
          lastNotifyMoment = nowMoment
        }
      }

      const notification = mapActivityData(data)

      yield put(addNotification({
        ...notification,
        wasRead: false,
        index: 0
      }))

      yield put(sagaActions.fetchUnreadNotificationsCount())
    } else if (actionName + elementName === 'RemoveUserNotification/Primitive/Int32') {
      const { Value } = data

      yield put(removeNotification({
        id: Value
      }))

      yield put(sagaActions.fetchUnreadNotificationsCount())
    } else if (actionName + elementName === 'ChangeProfileSettings/Data/Settings') {
      const { Settings } = data
      yield put(setCurrentUserSettings({
        lang: Settings.Lang,
        miniMenu: Settings.MiniMenu,
        activitiesDetailLevel: Settings.ActivitiesDetailLevel,
        notificationsDetailLevel: Settings.NotificationsDetailLevel,
        notificationOccurence: Settings.NotificationOccurence,
        notificationSound: Settings.NotificationSound,
        tiles: Settings.Tiles
      }))
    } else if (actionName + elementName === 'AddPersonalDate/Data/CalendarEvent') {
      const PersonalDate = data

      yield put(addPersonalDate({
        id: PersonalDate.Id,
        cardId: PersonalDate.CardId,
        type: CalendarItemTypes.PERSONAL,
        name: PersonalDate.Name,
        timestamp: PersonalDate.Timestamp
      }))
    } else if (actionName + elementName === 'RemovePersonalDate/Data/CalendarEvent') {
      const PersonalDate = data

      yield put(removePersonalDate({
        id: PersonalDate.Id
      }))
    } else if (actionName + elementName === 'RenamePersonalDate/Data/CalendarEvent') {
      const PersonalDate = data

      yield put(setPersonalDateName({
        id: PersonalDate.Id,
        name: PersonalDate.Name
      }))
    } else if (actionName + elementName === 'SetPersonalDate/Data/CalendarEvent') {
      const PersonalDate = data

      yield put(setPersonalDateTimestamp({
        id: PersonalDate.Id,
        timestamp: PersonalDate.Timestamp
      }))
    } else if (actionName + elementName === 'AddBookmark/Data/BookmarkData') {
      const Bookmark = data

      yield put(addBookmark({
        id: Bookmark.Activity.Id,
        timestamp: Bookmark.Timestamp,
        activity: mapActivityData(Bookmark.Activity)
      }))
    } else if (actionName + elementName === 'RemoveBookmark/Primitive/Int32') {
      const { Value } = data

      yield put(removeBookmark(Value))
    } else if (actionName + elementName === 'AddUserRole/Data/UserRole') {
      const { UserId, Name } = data

      yield put(addUserRole({
        userId: UserId,
        role: Name,
      }))
    } else if (actionName + elementName === 'RemoveUserRole/Data/UserRole') {
      const { UserId, Name } = data

      yield put(removeUserRole({
        userId: UserId,
        role: Name,
      }))
    } else if (
      actionName === 'AddBlockerToCard' ||
      actionName === 'RemoveBlockerFromCard' ||
      actionName === 'ChangeCardBlockerUser'
    ) {
      yield put(fetchUserBlockerCount())
    }
  }
}
